package ai.wagemix.net.models

import kotlinx.serialization.Serializable

interface WMReevaluateJD {
    val storedMixId: String
    companion object
}

fun WMReevaluateJD.Companion.kxs(storedMixId: String): KxsWMReevaluateJD {
    return KxsWMReevaluateJD(storedMixId = storedMixId)
}

fun WMReevaluateJD.toKxs(): KxsWMReevaluateJD = when (this) {
    is KxsWMReevaluateJD -> this
    else -> WMReevaluateJD.kxs(storedMixId = storedMixId)
}

@ConsistentCopyVisibility
@Serializable
data class KxsWMReevaluateJD internal constructor(
    override val storedMixId: String
): WMReevaluateJD